import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { VideoPlayer } from '@cotyorg/ccx-organism-video';
import {
  trackVideoPlayEvent,
  trackVideoMilestoneEvent,
} from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/video';
import {
  trackVideoPlay,
  trackVideoProgress,
  trackVideoComplete,
} from '@cotyorg/ccx-utils/js/tracking/google-analytics/events/video';

export const Video = ({ videos }) => (
  <div className="video-section">
    <div className="video-full-width video-margin-bottom">
      <VideoPlayer
        autoPlay
        videosStoreDataKey="video"
        showControls={false}
        config={{
          youtube: {
            playerVars: {
              controls: 1,
            },
            embedOptions: {
              host: 'https://www.youtube-nocookie.com',
            },
          },
        }}
        onProgress={({ url, duration, progress, videoMilestone }) => {
          // Adobe Analytics
          trackVideoMilestoneEvent({
            url,
            duration,
            progress,
            videoMilestone,
            title: R.path(['video', 'title'], videos),
          });
          // Google Analytics
          trackVideoProgress({
            url,
            duration,
            progress,
            videoMilestone,
            title: R.path(['video', 'title'], videos),
          });
        }}
        onPlay={({ url, duration, progress }) => {
          // Adobe Analytics
          trackVideoPlayEvent({
            url,
            duration,
            progress,
            title: R.path(['video', 'title'], videos),
          });
          // Google Analytics
          trackVideoPlay({
            url,
            duration,
            title: R.path(['video', 'title'], videos),
          });
        }}
        onEnded={({ url, duration, progress }) => {
          // Google Analytics
          trackVideoComplete({
            url,
            duration,
            progress,
            title: R.path(['video', 'title'], videos),
          });
        }}
      />
    </div>
  </div>
);

Video.propTypes = {
  videos: PropTypes.instanceOf(PropTypes.object),
};
